import { useState } from "react";
import { toast } from "sonner";
import { http } from "../../lib/api";
import { apiError } from "../../context/AuthContext";
import { useAdminList, AdminHead, Field, TextInput, PrimaryBtn, inputCls } from "./adminUi";

const KINDS = {
  welcome: "Newsletter welcome (featured destination)",
  order_confirmation: "Order confirmation + receipt",
  admin_new_order: "New order alert (store owner)",
  shipping_confirmation: "Shipping confirmation",
  tracking_update: "Tracking update",
  order_cancelled: "Order cancellation",
  refund_confirmation: "Refund confirmation",
  password_reset: "Password reset",
};

export default function AdminEmails() {
  const { data, reload } = useAdminList("/admin/emails");
  const [to, setTo] = useState("info@vacationapparelusa.com");
  const [kind, setKind] = useState("order_confirmation");
  const [busy, setBusy] = useState(false);
  const send = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await http.post("/admin/emails/test", { to, kind });
      toast.success(`Sample "${KINDS[kind]}" sent to ${to}`);
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setBusy(false);
      reload();
    }
  };
  return (
    <div data-testid="admin-emails">
      <AdminHead title="Transactional emails" sub="Sent automatically via SendGrid from info@vacationapparelusa.com. No promotional emails are sent." />
      <form onSubmit={send} className="rounded-3xl bg-white shadow-sm p-6 grid sm:grid-cols-[1fr_1fr_auto] gap-4 items-end" data-testid="test-email-form">
        <Field label="Send a sample to"><TextInput type="email" required value={to} onChange={(e) => setTo(e.target.value)} data-testid="test-email-to" /></Field>
        <Field label="Template">
          <select className={inputCls} value={kind} onChange={(e) => setKind(e.target.value)} data-testid="test-email-kind">
            {Object.entries(KINDS).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
          </select>
        </Field>
        <PrimaryBtn disabled={busy} data-testid="test-email-send">{busy ? "Sending..." : "Send sample"}</PrimaryBtn>
      </form>
      <div className="mt-6 rounded-3xl bg-white shadow-sm overflow-x-auto">
        <table className="w-full min-w-[720px] text-sm">
          <thead className="text-left text-navy/50 text-xs uppercase tracking-wider"><tr><th className="p-4">Sent</th><th>To</th><th>Email</th><th>Order</th><th>Status</th></tr></thead>
          <tbody>
            {data?.map((e, i) => (
              <tr key={i} className="border-t border-border" data-testid={`email-log-row-${i}`}>
                <td className="p-4 text-navy/60 whitespace-nowrap">{new Date(e.created_at).toLocaleString()}</td>
                <td>{e.to}</td>
                <td>{e.subject}</td>
                <td>{e.order_number}</td>
                <td><span className={`rounded-full px-2.5 py-1 text-xs font-bold ${e.status === "sent" ? "bg-emerald-100 text-emerald-800" : "bg-red-100 text-red-700"}`} title={e.error}>{e.status}</span></td>
              </tr>
            ))}
          </tbody>
        </table>
        {data && !data.length && <p className="p-8 text-center text-navy/50">No emails sent yet.</p>}
      </div>
    </div>
  );
}
